import { TY_SPECIAL_FORMS } from './ty-special-form';
import { SpecialForm } from './types';
import { INFIX_SPECIAL_FORMS } from './expr/infix-special-forms';
import { EXPR_SPECIAL_FORMS } from './expr/expr-special-forms';
import { REL_SPECIAL_FORMS } from './rel-special-forms';
import { MU_SPECIAL_FORMS } from './mu-special-forms';
import { WINDOW_SPECIAL_FORMS } from './expr/window-special-forms';

export * as DOCS from './docs';

export const SPECIAL_FORMS: Record<
  string,
  readonly [artiy: number | number[] | 'any', fn: SpecialForm]
> = {
  ...INFIX_SPECIAL_FORMS,
  ...WINDOW_SPECIAL_FORMS,
  ...EXPR_SPECIAL_FORMS,
  ...TY_SPECIAL_FORMS,
  ...REL_SPECIAL_FORMS,
  ...MU_SPECIAL_FORMS,
};
